import React from "react";
import dotProp from 'dot-prop-immutable';

/* Utilities */
import { trans } from '~/utilities';

export default function ProductSearchRadioFilter({ filters, filterKey, updateFilters, colClassName = 'col-12' }) {
    const filterIndex = filters?.indexOf(filters?.find(filter => filter.key === filterKey));
    const filter = filters[filterIndex]?.filters[0];
    const activeChoice = filter?.choices?.find(choice => choice.active) || null;

    const updateChoice = (key) => {
        updateFilters(dotProp.set(filters, `${filterIndex}.filters.0.choices`, choices => choices.map(choice => ({ ...choice, active: choice.key === key }))));
    }

    const capitalizeFirstLetter = (string) => {
        const nameMapping = {
            occasions: "Occasions",
            nieuw: "Nieuw",
            demo: "Demo",
            company_cars: "Company Cars",
        };

        if (nameMapping[string]) {
            return nameMapping[string];
        }

        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const sortOrder = {
         nieuw: 1,
         occasions: 2,
         demo: 3,
         company_cars: 4
     };

    return (
        <>
            <input type="hidden" name={`${filterKey}[]`} value={filter?.choices?.find(choice => choice.active)?.key} />
            <div className={colClassName}>
                <label className="form-label">{trans(`app.content_block.vehicle_search.filter.${filterKey}.label`)}</label>
                <div className="row gutters-3 gutters-xl-5 row__radio">
                    {filter?.choices?.sort((a, b) => (sortOrder[a.key] || 999) - (sortOrder[b.key] || 999)).map(choice => (
                        <div key={choice.key} className="col-auto">
                            <div className="custom-control custom-radio">
                                <input
                                    id={choice.key}
                                    value={choice.key}
                                    className="custom-control-input"
                                    type="radio"
                                    onChange={(e) => updateChoice(e.target.value)}
                                    checked={activeChoice?.key === choice.key}
                                />
                                <label
                                    htmlFor={choice.key}
                                    className="custom-control-label"
                                >
                                    {capitalizeFirstLetter(choice.name)}
                                </label>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}
